module.exports = __webpack_public_path__ + "img/purple.be5030ca.webp";